import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#312F41',
  boxShadow: 24,
  p: 4,
  color: 'white',
  borderRadius: '25px',
};

interface StoryDevModalProps {
  children: JSX.Element;
}

const StoryDevModal = ({ children }: StoryDevModalProps) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <span onClick={handleOpen}>{children}</span>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            In Development
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            This feature is still in development and will be available soon.
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default StoryDevModal;
